<div class="cadastro-tipo-servico-container">
  <div class="header">
    <h1>Cadastro de Serviços</h1>
    <button class="btn btn-primary" (click)="openModal(formModal, true)">Novo Serviço</button>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="filtroNome">Nome:</label>
          <input 
            type="text" 
            id="filtroNome" 
            class="form-control" 
            [(ngModel)]="filtroNome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por nome">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="filtroStatus">Status:</label>
          <select 
            id="filtroStatus" 
            class="form-control" 
            [(ngModel)]="filtroStatus"
            (change)="aplicarFiltros()">
            <option value="">Todos</option>
            <option value="Ativo">Ativo</option>
            <option value="Inativo">Inativo</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>&nbsp;</label>
          <button class="btn btn-secondary w-100" (click)="limparFiltros()">
            <i class="fa fa-times"></i> Limpar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tipoServico of tiposServicoPaginados">
          <td>{{ tipoServico.nome }}</td>
          <td>
            <span
              [class]="getStatusClass(tipoServico.ativo)"
              class="status-click"
              (click)="alterarStatus(tipoServico)"
              title="Clique para alterar status">
              {{ tipoServico.ativo ? 'Ativo' : 'Inativo' }}
            </span>
          </td>
          <td>
            <button class="btn btn-sm btn-warning me-1" (click)="editarTipoServico(tipoServico); openModal(formModal)" title="Editar">
              <i class="fa fa-edit"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && tiposServicoFiltrados.length === 0">
          <td colspan="3" class="text-center text-muted py-3">
            Nenhum serviço encontrado.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3" *ngIf="tiposServicoFiltrados.length > 0">
    <div class="d-flex align-items-center gap-2">
      <label class="mb-0">Itens por página:</label>
      <select class="form-control form-control-sm" style="width: 90px;" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
        <option [ngValue]="5">5</option>
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
      </select>
    </div>

    <div class="d-flex align-items-center gap-2">
      <span class="text-muted">Página {{ paginaAtual }} de {{ totalPaginas }}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
        Anterior
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">
        Próxima
      </button>
    </div>
  </div>

  <!-- Modal -->
  <ng-template #formModal>
    <div class="modal-header">
      <h4 class="modal-title">{{ tipoServicoSelecionado ? 'Editar Serviço' : 'Novo Serviço' }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="formTipoServico" (ngSubmit)="onSubmit()" class="form-container">
                 <div class="row">
           <div class="col-md-12">
             <div class="form-group">
               <label for="nome">Nome do Serviço:</label>
               <input 
                 type="text" 
                 id="nome" 
                 formControlName="nome" 
                 class="form-control"
                 [class.is-invalid]="isFieldInvalid('nome')"
                 placeholder="Digite o nome do tipo de serviço">
               <small class="text-danger" *ngIf="isFieldInvalid('nome')">
                 {{ getFieldError('nome') }}
               </small>
             </div>
           </div>
         </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="modalRef.dismiss()">Cancelar</button>
          <button type="submit" class="btn btn-primary ms-2" [disabled]="!formTipoServico.valid">Salvar</button>
        </div>
      </form>
    </div>
  </ng-template>
</div> 